import { useEffect, useState } from "react";
import { collection, query, where, orderBy, getDocs, getDoc, doc, documentId } from "firebase/firestore";
import { db } from "../firebase"; // import db từ config của bạn
import { useAuth } from "../hooks/useAuth"; // nếu bạn có context để lấy currentUser
import { useInView } from "react-intersection-observer";
import Post from './Post';

export default function Favorites() {
  const { currentUser } = useAuth();
  const [postIds, setPostIds] = useState([]);
  const [postCache, setPostCache] = useState({}); // { postId: postData }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;

    const fetchLikedIds = async () => {
      setLoading(true);
      const likesRef = collection(db, "likes");
      const likesQuery = query(likesRef, where("userId", "==", currentUser.uid), orderBy("createdDate", "desc"));
      const likesSnapshot = await getDocs(likesQuery);
      const ids = likesSnapshot.docs.map(doc => doc.data().postId);
      setPostIds(ids);
      setLoading(false);
    };

    fetchLikedIds();
  }, [currentUser]);

  if (loading) return <div>Đang tải danh sách...</div>;

  if (postIds.length === 0) return <p>Bạn chưa quan tâm bài viết nào.</p>;

  return (
    <div>
      <h2 className="text-lg font-bold mb-4">Bài viết đã quan tâm</h2>
      {postIds.map(postId => (
        <LazyPostItem
          key={postId}
          postId={postId}
          postCache={postCache}
          setPostCache={setPostCache}
        />
      ))}
    </div>
  );
}

// Component load khi visible
function LazyPostItem({ postId, postCache, setPostCache }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      if (!inView || postCache[postId]) return;
      setLoading(true);
      const postSnap = await getDoc(doc(db, "posts", postId));
      const postModel = postSnap.data();
      postModel.id = postId; // thêm id vào dữ liệu
      if (postSnap.exists()) {
        setPostCache(prev => ({ ...prev, [postId]: postModel }));
      }
      setLoading(false);
    };

    fetchPost();
  }, [inView, postId, postCache, setPostCache]);

  const postData = postCache[postId];

  return (
    <div ref={ref} className="mb-4 min-h-[80px]">
      {(!postData && loading) && <SkeletonPost />}
      {postData && (
        <Post key={postData.id || postData.createdDate} post={postData} />
      )}
    </div>
  );
}

// Skeleton UI
function SkeletonPost() {
  return (
    <div className="animate-pulse space-y-3">
      <div className="h-5 bg-gray-300 rounded w-2/3"></div>
      <div className="h-4 bg-gray-200 rounded w-full"></div>
      <div className="h-4 bg-gray-200 rounded w-5/6"></div>
    </div>
  );
}